module.exports = __webpack_public_path__ + "static/img/host.9415ca11.png";